// extracted by mini-css-extract-plugin
export default {"hiddenContainerSmall":"hiddenContainerSmall__OGQ0N","visibleContainerSmall":"visibleContainerSmall__YmVmO"};